import React from 'react';
import { Toaster } from 'react-hot-toast';

const ToastProvider: React.FC = () => (
  <Toaster
    position="top-right"
    toastOptions={{
      duration: 5000,
      style: { zIndex: 9999 },
    }}
  />
);

export default ToastProvider;
